import { CONFIGURATION_CANVAS_LEFT_PANEL_WIDTH } from '../configuration-canvas/consts';
import { AllocateLeftPanelSpace } from '../configuration-canvas/panels-reserve-space/AllocateLeftPanelSpace';
import { useExpandedMode } from '../configuration-canvas/panels-reserve-space/useExpandedMode';
import {
  ConfigurationCanvasPanelProps,
  ConfigurationCanvasPanel,
} from './ConfigurationCanvasPanel';
import { slideFromLeft } from '../../animations/cssAnimations';
import { useIsCanvasUnited } from '../../../hooks/useIsCanvasUnited';

export const ConfigurationCanvasLeftPanel: React.FC<
  ConfigurationCanvasPanelProps & {
    withExpandedModeButton?: boolean;
    expandedModeWithoutButton?: boolean;
  }
> = (props) => {
  const { isExpandedMode } = useExpandedMode();
  const isCanvasUnited = useIsCanvasUnited();
  const _width = props.width ?? CONFIGURATION_CANVAS_LEFT_PANEL_WIDTH;

  const panel = (
    <ConfigurationCanvasPanel
      positionSx={{
        position: isCanvasUnited ? 'absolute' : 'relative',
        top: 0,
        right: 'auto',
        left: 0,
        ...(isCanvasUnited ? slideFromLeft : {}),
      }}
      {...props}
      isExpandedMode={
        isExpandedMode && (props.withExpandedModeButton || props.expandedModeWithoutButton)
      }
      width={_width}
      id="configuration-canvas-left-panel"
    />
  );

  if (props.skipSizeAllocation) {
    return panel;
  }

  return <AllocateLeftPanelSpace size={_width}>{panel}</AllocateLeftPanelSpace>;
};
